import { LegacyPagePaths } from "App/routes/paths";

import { AgentsRerouter } from "./AgentsRoutingPage";

import type { RegalRouteObject } from "App/routes/types";

export const rerouteAgentsRoute: RegalRouteObject = {
    path: LegacyPagePaths.agents,
    element: <AgentsRerouter />,
    children: [
        {
            path: "*",
            element: <AgentsRerouter />,
        },
    ],
};
